import { useEffect, useRef, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Box, Chip } from '@pocketlaw/tetris';
import { useDocumentPreview } from './useDocumentPreview';
/**
 * Marks a table row as the document that is currently previewed in the `DocumentPreviewSidebar`,
 * and scrolls it into view when the user navigates to it from the preview.
 */
export function DocumentPreviewChip(props) {
    const { documentId, children } = props;
    const { documentId: documentPreviewId, isPreviewing, previewDocument } = useDocumentPreview();
    const isBeingPreviewed = Boolean(documentId) && documentPreviewId === documentId;
    const ref = useRef(null);
    const [hover, setHover] = useState(false);
    const handleClickCapture = (event) => {
        if (!isPreviewing || isBeingPreviewed) {
            return;
        }
        // Block the children routing and preview the document instead
        if (!event.target.closest('a')) {
            return;
        }
        event.preventDefault();
        previewDocument(documentId);
    };
    const handleMouseOver = () => {
        setHover(true);
    };
    const handleMouseOut = () => {
        setHover(false);
    };
    const getPreviewChip = () => {
        if (!isPreviewing) {
            return null;
        }
        if (isBeingPreviewed) {
            return (<Chip ref={ref} size="small" appearance="info" style={{ flexShrink: 0 }} label={t({ message: 'Preview', comment: 'Document table row - Chip marking the previewed document' })}/>);
        }
        if (hover) {
            return (<Chip ref={ref} size="small" appearance="secondary" style={{ flexShrink: 0 }} label={t({ message: 'Preview', comment: 'Document table row - Chip marking the previewed document' })}/>);
        }
        return null;
    };
    useEffect(() => {
        var _a, _b;
        if (isBeingPreviewed) {
            (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView) === null || _b === void 0 ? void 0 : _b.call(_a, { block: 'nearest', behavior: 'smooth' });
        }
    }, [isBeingPreviewed]);
    return (<Box gap="md" alignItems="center" style={{ overflow: 'hidden' }} onClickCapture={handleClickCapture} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
      {children}
      {getPreviewChip()}
    </Box>);
}
